import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useConsole } from "../../components/common/console/Console";
import { fnSavePreferences } from "../sputnikapi";
import { fnDebounceFunc } from "../shared";

export const processPreferencesQueue = fnDebounceFunc(async (dispatch: any, getState: Function) => {
  const { fnConsoleError } = useConsole()
  try {
    dispatch(setSaving(true));
    await fnSavePreferences(getState, dispatch);
    dispatch(clearUpdateQueue());
  } catch (oError) {
    console.error(oError)
    fnConsoleError(dispatch,oError)
  }  
  dispatch(setSaving(false));
}, 2000);

enum PrefType {
  User = 1,
  AdminStatus = 2,
  AdminSetting = 3,
  ServicesSettings = 4,
  TrendsSettings = 5,
  SputnikDeviceSettings = 6,
  NebulonSpreadConfig = 7,
  SputnikDeviceCommand = 8,
  TuyaScene = 9,
  SputnikDeviceStatus = 10,
  SweepSettings = 11,
}

interface UpdateQueueItem {
  type?: PrefType;
  prefname?: string;
  keyaddress: string;
  keyvalue: any;
  tagid?:number;
}

interface PrefsState {
    saving:boolean;
    updateQueue: UpdateQueueItem[];
}

const initialState: PrefsState = {
    saving: false,
    updateQueue: [],
};


const prefsSlice = createSlice({
  name: "prefs",
  initialState,
  reducers: {
    addToQueue: (state, action: PayloadAction<UpdateQueueItem>) => {
      // console.log(action)
      // state.updateQueue.push(action.payload);
      const newItem = action.payload;
  
      // Find an existing item that matches all properties except `keyvalue`
      const existingItemIndex = state.updateQueue.findIndex((item) => 
        item.type === newItem.type &&
        item.prefname === newItem.prefname &&
        item.keyaddress === newItem.keyaddress
      );
    
      if (existingItemIndex !== -1) {
        // console.log('updated',newItem)
        // If found, update the `keyvalue` of the existing item
        state.updateQueue[existingItemIndex].keyvalue = newItem.keyvalue;
        state.updateQueue[existingItemIndex].tagid = newItem.tagid;
      } else {
        // If not found, add the new item to the queue
        // console.log('added',newItem)
        state.updateQueue.push(newItem);
      }

    },
    clearUpdateQueue: (state) => {
      state.updateQueue = [];
    },
    setSaving: (state, action: PayloadAction<boolean>) => {
      state.saving = action.payload;
    }
  },
});

export const { addToQueue, clearUpdateQueue, setSaving } = prefsSlice.actions;
export const selectUpdateQueue = (state: { prefs: PrefsState }) => state.prefs.updateQueue;
export const itemPendingInSaveQueue = (state: { prefs: PrefsState }, type: PrefType, prefname?: string, keyaddress?: string, keyvalue?: any) => {
  return state.prefs.updateQueue.some(item =>
    item.type === type &&
    (prefname ? item.prefname === prefname : true) &&
    (keyaddress ? item.keyaddress.includes(keyaddress) : true) &&
    (keyvalue ? item.keyvalue === keyvalue : true)
  );
};
export default prefsSlice.reducer;
export type { UpdateQueueItem, PrefType };
